var ACC                = ACC || {};
ACC.cart               = ACC.cart || {};

ACC.cart.bindAll = function () {
    this.bindCartRemoveProduct();
    ACC.customarticlecode.bindAll();
};

ACC.cart.bindCartRemoveProduct = function () {
    $('.qtyUnit').on('change', function (e) {
        e.preventDefault();

        var $form = $(e.target).closest('form');
        var entryNumber = $form.find('input[name=entryNumber]').val();
        var productCode = $form.find('input[name=productCode]').val();
        var cartCode = $form.find('input[name=cartCode]').val();
        var qtyUnit = $(e.target).val();

        var method = "POST";
        $.ajax({
            url: ACC.cart.updateQuantityUnitUrl,
            data: {productCode: productCode, quantityUnit: qtyUnit, entryNumber: entryNumber, cartCode: cartCode},
            type: method,
            success: function (data, textStatus, xhr) {
                window.location.reload();
            },
            error: function (xhr, textStatus, error) {
                window.location.reload();
            }
        });
    });

    $(document).on("click", '.js-submit-remove-product', function () {
        var $form = $(this).closest("form");
        var initialCartQuantity = $form.find('input[name=initialQuantity]');
        var cartQuantity = $form.find('input[name=quantity]');
        var entryNumber = $form.find('input[name=entryNumber]').val();
        var productCode = $form.find('input[name=productCode]').val();
        var cartCode = $form.find('input[name=cartCode]').val();

        cartQuantity.val(0);
        initialCartQuantity.val(0);

        ACC.track.trackRemoveFromCart(productCode, initialCartQuantity, cartQuantity.val());

        var method = $form.attr("method") ? $form.attr("method").toUpperCase() : "GET";
        $.ajax({
            url: $form.attr("action"),
            data: $form.serialize(),
            type: method,
            success: function (data) {
                location.reload(true);
            }
        });

    });

    $(document).on("click", ".js-add-certificate-form a", function (e) {
        e.preventDefault();
        KMVP.tooltips.handlePopoverCloseClick(e);
    });

    $(document).on("change", ".js-add-certificate-form select", function (e) {
        e.preventDefault();
        if ($(this).val() == "") {
            $(".js-add-certificate-form button").attr('disabled', 'disabled');
        } else {
            $(".js-add-certificate-form button").removeAttr("disabled");
        }
    });

    // for non multi-d products
    $(document).on("keypress", '.qty', function (e) {
        var $input = $(this);
        if ((e.keyCode || e.which) == 13) // Enter was hit
        {
            e.preventDefault();
            $input.blur();
        }
    });

    // for non multi-d products
    $(document).on("blur", '.qty', function () {
        var $form = $(this).closest("form");
        var itemIndex = $(this).data("index");

        var productCode = $form.find('input[name=productCode]').val();
        var entryNum = $form.find('input[name=entryNumber]').val();
        var initialCartQuantity = $form.find('input[name=initialQuantity]').val();
        var newCartQuantity = $form.find('input[name=quantity]').val();
        var cartCode = $form.find('input[name=cartCode]').val();

        if (initialCartQuantity != newCartQuantity) {
            ACC.track.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);

            $(this).closest('form').submit();
        }
    });

    // fixlength
    $(document).on("keypress", '.fixlength', function (e) {
        var $input = $(this);
        if ((e.keyCode || e.which) == 13) // Enter was hit
        {
            e.preventDefault();
            $input.blur();
        }
    });

    // fixlength
    $(document).on("blur", '.fixlength', function () {
        var $form = $(this).closest("form");
        var itemIndex = $(this).data("index");

        var productCode = $form.find('input[name=productCode]').val();
        var entryNum = $form.find('input[name=entryNumber]').val();
        var initialCartQuantity = $form.find('input[name=initialQuantity]').val();
        var newCartQuantity = $form.find('input[name=quantity]').val();
        var cartCode = $form.find('input[name=cartCode]').val();
        //initialFixedLengthPieces
        var initialFixedLengthPieces = $form.find('input[name=initialFixedLengthPieces]').val();
        var fixedLengthPieces = $form.find('input[name=fixedLengthPieces]').val();

        if (initialFixedLengthPieces != fixedLengthPieces) {
            // TODO: ?
            //ACC.track.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);

            var method = $form.attr("method") ? $form.attr("method").toUpperCase() : "GET";

            $.ajax({
                url: $form.attr("action"),
                data: $form.serialize(),
                type: method,
                success: function (data, textStatus, xhr) {
                    ACC.cart.refreshCartData(data, entryNum, newCartQuantity, itemIndex);
                    initialCartQuantity = newCartQuantity;
                    $form.find('input[name=initialQuantity]').val(initialCartQuantity);
                    // set initialFixedLengthPieces
                    $form.find('input[name=initialFixedLengthPieces]').val(fixedLengthPieces);
                },
                error: function (xhr, textStatus, error) {
                    var redirectUrl = xhr.getResponseHeader("redirectUrl");
                    var connection = xhr.getResponseHeader("Connection");
                    // check if error leads to a redirect
                    if (redirectUrl !== null) {
                        window.location = redirectUrl;
                        // check if error is caused by a closed connection
                    } else if (connection === "close") {
                        window.location.reload();
                    }
                }
            });
        }
    });
};

ACC.cart.getProductQuantity = function (gridContainer, mapData) {
    var skus = jQuery.map(gridContainer.find("input[type='hidden'].sku"), function (o) {
        return o.value
    });
    var quantities = jQuery.map(gridContainer.find("input[type='textbox'].sku-quantity"), function (o) {
        return o
    });

    var totalPrice = 0.0;
    var totalQuantity = 0.0;

    $.each(skus, function (index, skuId) {
        var quantity = mapData[skuId];
        if (quantity != undefined) {
            quantities[index].value = quantity;
            totalQuantity += parseFloat(quantity);

            var indexPattern = "[0-9]+";
            var currentIndex = parseInt(quantities[index].id.match(indexPattern));

            var currentPrice = $("input[id='productPrice[" + currentIndex + "]']").val();
            totalPrice += parseFloat(currentPrice) * parseInt(quantity);
        }
    });

    var subTotalValue = Currency.formatMoney(Number(totalPrice).toFixed(2), Currency.money_format[ACC.common.currentCurrency]);
    var avgPriceValue = 0.0;
    if (totalQuantity > 0) {
        avgPriceValue = Currency.formatMoney(Number(totalPrice / totalQuantity).toFixed(2), Currency.money_format[ACC.common.currentCurrency]);
    }

    gridContainer.parent().find('#quantity').html(totalQuantity);
    gridContainer.parent().find("#avgPrice").html(avgPriceValue);
    gridContainer.parent().find("#subtotal").html(subTotalValue);

    var $inputQuantityValue = gridContainer.parent().find('#quantityValue');
    var $inputAvgPriceValue = gridContainer.parent().find('#avgPriceValue');
    var $inputSubtotalValue = gridContainer.parent().find('#subtotalValue');

    $inputQuantityValue.val(totalQuantity);
    $inputAvgPriceValue.val(Number(totalPrice / totalQuantity).toFixed(2));
    $inputSubtotalValue.val(Number(totalPrice).toFixed(2));
};

ACC.cart.refreshCartData = function () {
    location.reload(true);
};

ACC.cart.handleSaleProductsInCart = function () {
    $('input[name=quantity]').on("input", function (e) {
        var $inputField = $(e.currentTarget);   // targeted input filed
        var quantity = parseInt($inputField.val());       // value of input field
        var $orderItem = $inputField.closest(".order-item"); // dummy element to find stock availability input field and update the layout of order entry
        var stockAvailability = parseInt($orderItem.find($('input[name=stockLevel]')).val()); //stock availability for targeted order entry

        if (quantity > stockAvailability) {
            $orderItem.find(".js-article-low-stock").removeClass("hide");
            $orderItem.find(".js-entry-modified-stock-message").removeClass("hide");
            $orderItem.addClass("sale-product-low-availability");

        } else {
            $orderItem.find(".js-article-low-stock").addClass("hide");
            $orderItem.find(".js-entry-modified-stock-message").addClass("hide");
            $orderItem.removeClass("sale-product-low-availability");
        }
    });
};

ACC.cart.showToolTips = function () {
    setTimeout(function() {
            $(".js-tooltip-export").popover("show");
        }, 500);
};

$(document).ready(function () {
    ACC.cart.bindAll();
    ACC.cart.handleSaleProductsInCart();
    ACC.cart.showToolTips();
});